import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME, buttons, INVENTORY_PARTS_DATA, DependentTableNames } from './constants';

function reportUrlByName(routeName: string): string {
	return buttons.find((item) => item.routeName === routeName)?.api!;
}

class SestavyApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case INVENTORY_PARTS_DATA:
				return '/Nd/NdSklad/InventoryDashboardSchema';
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case INVENTORY_PARTS_DATA:
				return '/Nd/NdSklad/InventoryDashboardRows';
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	getReport(routeName:string, filter: {}) {
		const apiName = reportUrlByName(routeName);
		return this.fetchPdf(`${this.apiPath}${apiName}`, filter);
	}

	getAccessFlag() {
		return this.fetch(`${this.apiPath}GetAccessFlag`);
	}

	getSkladMistoData() {
		return this.fetch('/Nd/NdSklad/GetSkladMistoDDData');
	}

	getDealerKVPSDDData() {
		return this.fetch('/Nd/NdSklad/GetDealerKVPSDDData');
	}

	getPartsCategoryDDData() {
		return this.fetch('/Nd/NdSklad/GetPartsCatagoryDDData');
	}
}

export const apiProvider = new SestavyApi();
